// image-processing-loader
var previousRequest = require("!!../../../../../node_modules/fox-file-loader/index.js!../../../../../node_modules/file-loader/index.js?name=[path][name].[ext]!./liveshow-block-image.jpg");
var dir = previousRequest.replace("liveshow-block-image.jpg", "")
module.exports = require("!../../../../../node_modules/fox-image-optimize-plugin/router.js")({
	dir: dir,
	base: "liveshow-block-image.jpg",
	name: "liveshow-block-image",
	ext: ".jpg",
	query: ""
}, previousRequest);


//////////////////
// WEBPACK FOOTER
// ./images/liveshow-block-image.jpg
// module id = 88
// module chunks = 4